module.exports = __webpack_public_path__ + "img/-s-pic_product zdyw_cpjg.947ef39d.svg";